import {
  Modal,
  Form,
  Col,
  Row,
  Input,
  Button,
  notification,
  Upload,
  Select,
} from "antd";
import React, { useState } from "react";
import { DownloadOutlined, UploadOutlined } from "@ant-design/icons";
import { ExcelUpload } from "../shared/excel";
import _ from "lodash";
import {
  bulkCustomersUpload,
  getApiUrl,
  createUser,
  getCustomerDownload,
} from "../shared/camp-helper";
import { COUNTRY_CODE,CUSTOMER_ROLEID } from "../shared/camp-constant-values";
import Cookies from "js-cookie";
import { isEmpty } from "lodash";

const { Option } = Select;
const AddUser = (properties) => {
  const { openUserModal, handleClose } = properties;
  const [openBulkUser, setOpenBulkUser] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [enable, setEnable] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [apiUrl] = useState(Cookies.get("apiUrl"));
  const [loading, setLoading] = useState(false);

  const dummyRequest = ({ onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const handlerReset = () => {
    setFileList([]);
    setExcelData([]);
    setEnable(false);
    setConfirmLoading(false);
  };
  const downloadExcelTemplate = async () => {
    const data = {
      apiUrl,
      filterName: "user",
    };
    const api_url = await getApiUrl(data);
    getCustomerDownload(api_url[0])
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "customerupload.xlsx");
        document.body.appendChild(link);
        link.click();
      })
      .catch(() => {
        notification.error({
          message: "Failed to download customer details",
        });
      });
  };

  const handleOpenBulk = () => {
    setOpenBulkUser(true);
  };
  const handleBulkClose = () => {
    setOpenBulkUser(false);
  };
  const handleFileList = ({ fileList: fileListName }) => {
    setFileList(fileListName);
    if (fileListName) {
      setEnable(false);
    }
  };

  const handleValidate = async () => {
    if (!fileList.length) {
      return notification.error({ message: "Upload the Customer list file" });
    }
    if (
      !_.has(excelData, "[0].user_name", "") ||
      !_.has(excelData, "[0].phone_number", "")
    ) {
      return notification.error({
        message: "Please fill the Customer Detail Sheet",
      });
    }
    const customerDetailCheck = [];
    const checkCustomers = excelData.every((excel) => {
      if (excel.user_name && excel.phone_number) return true;
      if (!excel.user_name) customerDetailCheck.push("User Name");
      if (!excel.phone_number) customerDetailCheck.push("Mobile Number");
      return false;
    });
    if (!checkCustomers) {
      return notification.error({
        message: `Please fill the ${customerDetailCheck.join(",")} field(s)`,
      });
    }
    const phoneCheck = _.sortBy(_.map(excelData, "phone_number"));
    const emailPick = _.pickBy(excelData, (value) => value.email_address);
    const emailCheck = _.sortBy(_.map(emailPick, "email_address"));
    const userPattern = /^[\w]+[\w ]*[\w]$/;
    const numberPattern = /^[\d]{10}$/;
    const emailPattern = /^[\w]+[\w.!#$%&*+/=?^_`{|}~-]+@[\w-]+[.]+[\w-]{2,3}$/;
    const customerDetailValidate = [];
    const validateCustomers = excelData.every((excel) => {
      if (
        userPattern.test(excel.user_name) &&
        numberPattern.test(excel.phone_number) &&
        (!excel.email_address || emailPattern.test(excel.email_address))
      )
        return true;
      if (!userPattern.test(excel.user_name))
        customerDetailValidate.push("User Name");
      if (!numberPattern.test(excel.phone_number))
        customerDetailValidate.push("Mobile Number");
      if (excel.email_address && !emailPattern.test(excel.email_address))
        customerDetailValidate.push("Email");
      return false;
    });
    if (!validateCustomers) {
      return notification.error({
        message: `Please fill the valid ${customerDetailValidate.join(
          ","
        )} field(s)`,
      });
    }
    if (phoneCheck.length !== _.uniq(phoneCheck).length) {
      return notification.error({ message: `Duplicate Mobile Number` });
    }
    if (emailCheck.length !== _.uniq(emailCheck).length) {
      return notification.error({ message: `Duplicate Email Address` });
    }
    const files = {
      sheet: [fileList[0].originFileObj],
    };
    const data = {
      apiUrl,
      filterName: "user",
    };
    const api_url = await getApiUrl(data);
    await bulkCustomersUpload({ validate: true }, files, api_url[0])
      .then((response) => {
        if (_.get(response, "data.success", "")) {
          notification.success({
            message: "Validation success",
          });
          setEnable(true);
        } else {
          notification.error({
            message: _.get(response, "data.message", ""),
          });
        }
      })
      .catch((error_) => {
        setConfirmLoading(false);
        notification.error({
          message: error_.message || "Some error occurred while uploading ",
        });
      });

    return null;
  };
  const handleOk = async () => {
    setConfirmLoading(true);
    const files = {
      sheet: [fileList[0].originFileObj],
    };
    const data = {
      apiUrl,
      filterName: "user",
    };
    const api_url = await getApiUrl(data);
    await bulkCustomersUpload({}, files, api_url[0])
      .then(() => {
        setConfirmLoading(false);
        setFileList([]);
        setExcelData([]);
        notification.success({
          message: "Data has been successfully uploaded",
        });
        handleClose();
        setEnable(false);
      })
      .catch((error_) => {
        setConfirmLoading(false);
        notification.error({
          message: error_.message || "Some error occurred while uploading",
        });
      });
  };
  const fileResponse = (response) => {
    const customerDetails = _.get(response, '[0]', []).map((item) => {
      return {
        user_name: item['User Name'],
        phone_number: item['Mobile Number'],
        email_address: item['Email (Optional)'],
      };
    });
    setExcelData(customerDetails);
  };
  const handleUpload = async (file) => {
    const uploadFormat = _.get(file, "name", "").split(".")[1];
    const acceptedFormats = ["xlsx", "xls", "csv"];
    if (!acceptedFormats.includes(uploadFormat)) {
      notification.error({ message: "Upload the proper file format" });
      setFileList([]);
    }
    await ExcelUpload(file, fileResponse);
  };

  const onFinish = async (values) => {
    const data = {
      apiUrl,
      filterName: "user",
    };
    if (values.phone) {
      if (!/^\d{10}$/.test(values.phone)) {
        return notification.error({
          message: "Please Enter valid Phone Number",
        });
      }
    }
    const api_url = await getApiUrl(data);
    const params = {
      user_name: values.username,
      phone_number: values.phone,
      email_address: values.email || "",
      country_code: COUNTRY_CODE,
      role_id:CUSTOMER_ROLEID,
    };
    setLoading(true);
    createUser(params, api_url[0])
      .then((res) => {
        if (isEmpty(res.data.data)) {
          notification.error({
            message: res?.data.message || "Phone Number is Already Exists",
          });
          setLoading(false);
        } else {
          handleClose();
          notification.success({
            message: "Successfully Created",
          });
          setLoading(false);
        }
      })
      .catch((error) => {
        notification.error({
          message: error || "Some error occurred while generating customer",
        });
        setLoading(false);
      });
  };
  const prefixSelector = (
    <Form.Item name="prefix" noStyle>
      <Select
        style={{
          width: 70,
        }}
        defaultValue="+91"
      >
        <Option disabled value="+91">
          +91
        </Option>
      </Select>
    </Form.Item>
  );

  return (
    <>
      <Modal
        title="Add New User"
        footer={null}
        visible={openUserModal}
        onCancel={handleClose}
      >
        <Form onFinish={onFinish} autoComplete="off">
          <Form.Item
            label="Customer Name"
            name="username"
            rules={[
              {
                required: true,
                message: "Please input your customer!",
              },
            ]}
          >
            <Input size="middle" />
          </Form.Item>
          <Form.Item
            label="Customer Phone"
            name="phone"
            rules={[
              {
                required: true,
                message: "Please input your Phone Number!",
              },
            ]}
          >
            <Input addonBefore={prefixSelector} type="number" size="middle" />
          </Form.Item>
          <Form.Item
            label="Email (Optional)"
            name="email"
            rules={[
              {
                type: "email",
                message: "The input is not valid E-mail!",
              },
            ]}
          >
            <Input size="middle" />
          </Form.Item>

          <Row>
            <Col span={8}>
              <Button onClick={() => handleOpenBulk()} type="primary">
                Bulk Upload
              </Button>
            </Col>
            <Col span={16}>
              <Form.Item>
                <div className="footer-btn">
                  <Button onClick={handleClose}>Cancel</Button>
                  <Button
                    loading={loading}
                    className="ml-2"
                    type="primary"
                    htmlType="submit"
                  >
                    Submit
                  </Button>
                </div>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      {openBulkUser && (
        <Modal
          title="Import Customers"
          okText="Import"
          visible={openBulkUser}
          onCancel={handleBulkClose}
          maskClosable={false}
          width={600}
          className="bulk-user-modal"
          footer={[
            <Button
              icon={<DownloadOutlined />}
              onClick={downloadExcelTemplate}
              className="download-customer-temp-btn"
            >
              Download Template
            </Button>,
            <Button danger type="default" onClick={handleValidate}>
              Validate
            </Button>,
            <Button
              type="primary"
              loading={confirmLoading}
              disabled={!enable}
              onClick={handleOk}
            >
              Import
            </Button>,
            <Button danger type="default" onClick={handlerReset}>
              Reset
            </Button>,
          ]}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
            }}
          >
            <Row
              gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
              className="customer-file-upload-popup-row"
            >
              <Col className="gutter-row" span={24}>
                <div className="customer-file-upload-popup">
                  <Upload
                    customRequest={dummyRequest}
                    beforeUpload={handleUpload}
                    onChange={handleFileList}
                    fileList={fileList}
                    maxCount={1}
                  >
                    <Button icon={<UploadOutlined />}>Click to Upload</Button>
                  </Upload>
                </div>
              </Col>
            </Row>
          </div>
        </Modal>
      )}
    </>
  );
};

export default AddUser;
